export const partnersListKey = () => ["partners-list"];

export const partnersListParamsKey = ({ queryParams }) => [...partnersListKey(), queryParams];
